import { getDateVal } from "./utils";

// 日期格式化
export const formatDateFromFilterValue = (value: any):any => {
  const { rangeTime } = value || {};
  const [start, end] = rangeTime;
  return {
    ...value,
    rangeTime: [ getDateVal(start, 'YYYY-MM-DD'),  getDateVal(end, 'YYYY-MM-DD')],
  };
};